import React from "react";
import CheckIcon from "../../Resources/Icons/CheckIcon";

class Button extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {

	const styles = {
		padding: "10px 22px",
		fontSize: "15px",
		fontFamily: "'roboto' sanserif",
		background: "#015fd1",
		color: "white",
		borderRadius: "30px",
		outline: "none",
		border: "none"
	}
    const props = this.props;
    return (
      <React.Fragment>
        <div
          style={{
            position: "relative",
            margin: !props.noMargin ? "10px auto" : "",
            maxWidth: props.maxWidth,
          }}
        >
          <button
            className={`btn btn--crv ${props.focus ? "focus" : ""} ${
              props.type === "primary"
                ? "btn--primary"
                : props.type === "default"
                ? "btn--default"
                : props.type === "noStyle"
                ? "btn--no-style"
                : props.type === "success"
                ? "btn--success"
                : props.type === "outline"
                ? "btn-outline--blue"
                : props.type === "link"
                ? "btn--link"
                : props.type === "plain"
                ? "btn--plain"
                : ""
            } ${props.display === "block" ? "btn--block" : ""} ${
              props.loading ? "is-loading" : ""
            } ${
              props.size === "small"
                ? "btn--sm"
                : props.size === "tiny"
                ? "btn--xs"
                : ""
            }`}
            style={{
              padding: props.type === "link" ? "" : "10px 22px",
              margin: props.margin,
              fontSize:
                props.size === "small" || props.size === "tiny"
                  ? "12px"
                  : props.type === "link"
                  ? ""
                  : "15px",
              backgroundColor: props.color,
            }}
            disabled={props.disabled}
            {...(props.onClick && {
              onClick: props.loading ? () => null : props.onClick,
            })}
            {...(props.focus && {
              tabIndex: 0,
            })}
            {...(props.formId && {
              form: props.formId,
            })}
            id={props.id}
            {...(props.buttonType && {
              type: "button",
            })}

			style={styles}
          >
            {props.loadingComplete ? (
              <CheckIcon color={"#fff"} height={"14px"} width={"14px"} />
            ) : (
              props.children || props.text
            )}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default Button;
